import NiceModal, { useModal } from "@ebay/nice-modal-react";
import { useCustomModel } from "components/context/CustomProvider";
import CustomDialog from "../CustomDialog";
import CustomForm from "../forms/CustomForm";
import { useNiceModalLocker } from "components/context/NiceModalProvider";
import useCustomDataSource from "../useCustomDataSource";

const ModelCreateModal = ({ modelName, initialValuesFromParent }) => {
  if (!modelName) {
    throw new Error("ModelCreateModal requires a modelName");
  }

  return NiceModal.create(({ initialValues, parent, onDone }) => {
    const modal = useModal();
    const model = useCustomModel(modelName);
    const dataSource = useCustomDataSource(modelName);
    const { locked, setLocked, closeFormIfNotLocked, forceClose } =
      useNiceModalLocker(modal);

    return (
      <CustomDialog
        variant="dialog"
        open={modal.visible}
        onClose={closeFormIfNotLocked}
      >
        <CustomForm
          title={`Create ${model.modelName}${locked ? " (Locked)" : ""}`}
          defaultValues={
            initialValues ||
            (initialValuesFromParent && initialValuesFromParent(parent)) ||
            {}
          }
          fields={model.fields}
          submitter={dataSource.createOne}
          onDone={onDone}
          onCancel={forceClose}
          onIsDirty={setLocked}
          modelName={modelName}
        />
      </CustomDialog>
    );
  });
};

export default ModelCreateModal;
